<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: "App" };
</script>

<style>
body { margin: 0; font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"PingFang SC","Helvetica Neue",Arial,"Noto Sans",sans-serif; }
a { color: inherit; }
</style>